"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

function navClass(active: boolean) {
  return `ed-blog-nav__link${active ? " ed-blog-nav__link--active" : ""}`;
}

/** Highlights Tools vs Saved for tools/marketing chrome. */
export function BlogPrimaryNav() {
  const pathname = usePathname() || "";

  const toolsActive = pathname.startsWith("/tools");

  return (
    <>
      <Link href="/tools/expiry-calculator" className={navClass(toolsActive)} aria-current={toolsActive ? "page" : undefined}>
        Tools
      </Link>
      <Link href="/blog/saved" className={navClass(pathname === "/blog/saved")} aria-current={pathname === "/blog/saved" ? "page" : undefined}>
        Saved
      </Link>
      <Link href="/blog/newsletter" className="ed-blog-nav__link ed-blog-nav__link--cta">
        Free Newsletter
      </Link>
    </>
  );
}
